var React = require('react');

function Attachment (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#000"},React.createElement("path",{"d":"M1552.5 754c-6.342 0-11.5-5.186-11.5-11.563V726.25c0-.853.687-1.542 1.533-1.542.847 0 1.534.69 1.534 1.542v16.188c0 4.674 3.782 8.479 8.433 8.479 4.65 0 8.433-3.805 8.433-8.48V725.48c0-2.975-2.407-5.396-5.366-5.396-2.96 0-5.367 2.42-5.367 5.396v15.417c0 1.275 1.032 2.312 2.3 2.312 1.268 0 2.3-1.037 2.3-2.312V726.25c0-.853.687-1.542 1.533-1.542.847 0 1.534.69 1.534 1.542v14.646c0 2.975-2.408 5.396-5.367 5.396-2.96 0-5.367-2.42-5.367-5.396v-15.417c0-4.674 3.783-8.479 8.434-8.479 4.65 0 8.433 3.805 8.433 8.48v16.957c0 6.377-5.158 11.563-11.5 11.563","transform":"translate(-1541.000000, -717.000000)"}))));
}

Attachment.defaultProps = {"width":"23","height":"37","viewBox":"0 0 23 37"};

module.exports = Attachment;

Attachment.default = Attachment;
